import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export default function PricingCard({ plan, isYearly, onSelect }) {
  const isPopular = plan.highlight_badge === 'Most Popular';
  const isCustom = plan.type === 'Custom';

  // Calculate pricing based on yearly vs monthly
  let priceText = '';
  let periodText = '';
  let subText = '';

  if (isCustom) {
    priceText = 'Custom';
  } else if (isYearly) {
    // If yearly, yearly_price represents the yearly sum. We show monthly equivalent or yearly sum.
    const monthlyEquivalent = (parseFloat(plan.yearly_price) / 12).toFixed(2);
    priceText = `$${monthlyEquivalent}`;
    periodText = '/mo';
    subText = `Billed yearly ($${parseFloat(plan.yearly_price).toFixed(2)}/yr)`;
  } else {
    priceText = `$${parseFloat(plan.monthly_price).toFixed(2)}`;
    periodText = '/mo';
  }

  const handleCtaClick = () => {
    if (isCustom) {
      window.location.href = '/support?subject=Sales%20Inquiry';
    } else {
      onSelect(plan);
    }
  };

  return (
    <div className={`pricing-card ${isPopular ? 'popular' : ''}`}>
      {plan.highlight_badge && (
        <div className="popular-badge">{plan.highlight_badge}</div>
      )}
      <div className="plan-name">{plan.name}</div>
      <div className="plan-desc">{plan.description}</div>
      
      <div className="plan-price-container">
        <div className="plan-price-large">
          {priceText}
          {!isCustom && <span className="plan-price-period">{periodText}</span>}
        </div>
        {subText && <div className="plan-price-yearly-sub">{subText}</div>}
      </div>

      <button 
        onClick={handleCtaClick} 
        className={`plan-cta-btn ${isPopular ? '' : 'secondary'}`}
      >
        {isCustom ? 'Let\'s talk' : plan.cta_label}
      </button>

      <ul className="plan-features-list">
        {plan.features && plan.features.map((feat) => (
          <li key={feat.id} className="plan-feature-item">
            <FontAwesomeIcon icon={faCheckCircle} className="plan-feature-icon" />
            <span>{feat.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
